module.exports = __webpack_public_path__ + "img/welcome.e63d9586.png";